import * as React from 'react';
import * as _ from 'lodash';
import {
  API,
  Logging,
  NotificationData,
  Notification,
  ResponseError,
  getUuidV4,
  ContactCollection,
} from '@vcd-ecm-ui/Common';
import {
  FilterModelApi,
  GenericGrid,
  GridDataSummaryCollection,
  SortModelApi,
} from '@vcd-ecm-ui/GenericGrid';
import { VtxButton, VtxColumnProps, VtxIcon } from '@vertexinc/vtx-ui-react-component-library';
import ContactsProps from './ContactsProps.interface';
import GridRowData, { GridDataNativeType } from './GridRowData';
import getDefaultColumns, { additionalTableSettings } from './defaultColumns';
import './contacts.scss';

const Contacts = ({
  gatewayEndPoint,
  contacts,
  customerUuid,
  hasParent,
}: ContactsProps): JSX.Element => {
  const [notification, setNotification] = React.useState(null);

  // Parse each row from the Native Data Type to the Actual Data Type
  const rowParser = (row: GridDataNativeType): GridRowData => GridRowData.fromData(row);

  // Get the Columns for the Grid
  const getColumns = (): VtxColumnProps<GridRowData>[] => {
    // Get the Default Columns
    const defaultColumns: VtxColumnProps<GridRowData>[] = getDefaultColumns();

    return defaultColumns;
  };

  // The API Call used to retrieve data for the Grid
  const apiGetRowsServerModel = (
    startRow:number,
    endRow:number,
    filterModel: FilterModelApi,
    sortModel: SortModelApi,
  ): Promise<GridDataSummaryCollection> => {
    const api = new API(gatewayEndPoint);

    // FIX ME.  This API needs to support Filtering & Sorting.  Also needs to return Paging data and in "aodata", "value" format
    return api.customer.getCustomersContactsV41(customerUuid, startRow, endRow, filterModel, sortModel);
  };

  // Notification Error was Closed
  const onCloseNotification = (): void => {
    setNotification(null);
  };

  React.useEffect(() => {
    // This Code will run once after the initial Render
    Logging.Debug('Contacts: Mount');

    return (): void => {
      // This Code will run once the component unmounts.
    };
  }, []);

  return (
    <>
      <div className="contactsContainer">
        <div className="contactsContentGrid">
          <GenericGrid<GridRowData>
            id="contactsGrid"
            dataTypeDescription="Contacts"
            getDefaultColumns={getColumns}
            rowParser={rowParser}
            verticalHeightOffset={hasParent ? 446 : 415}
            additionalTableSettings={additionalTableSettings}
            // model="server"
            // apiGetRowsServerModel={apiGetRowsServerModel}
            model="static"
            dataRows={contacts}
          />
        </div>
        <Notification
          data={notification}
          onNotificationClose={onCloseNotification}
          autoClose
        />
      </div>
    </>
  );
};

export default Contacts;
